<template>
    <div v-if="activeClient" class="codes-edit-content">
        <div v-for="(item, index) in activeClient.codes" :key="index" class="code-block">
            <div class="edit-row">
                <span class="row-title">{{ "Code" | t }}</span>
                <v-text-field
                    :value="item.code"
                    class="compact-input"
                    dense
                    hide-details
                    outlined
                    @input="updateCodeField($event, 'code', index)"
                />
                <v-btn icon small class="ml-2" color="error" @click.stop="deleteCode(index)">
                    <v-icon small>delete</v-icon>
                </v-btn>
            </div>
            <div class="edit-row">
                <span class="row-title">{{ "Partner" | t }}</span>
                <v-select
                    :items="partners"
                    :value="item.partner"
                    class="compact-input"
                    dense
                    hide-details
                    outlined
                    @input="updateCodeField($event, 'partner', index)"
                />
            </div>
            <v-divider v-if="index < activeClient.codes.length - 1" class="my-2" />
        </div>
        <v-btn x-small color="bal-red" dark class="mt-2" @click.stop="addNewCode">
            <v-icon x-small class="mr-1">add</v-icon>
            {{ "Add new" | t }}
        </v-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "client-codes-edit-tab",
    data() {
        return {
            partners: ["odoo", "eugesta", "smarten"]
        };
    },
    computed: {
        ...mapState("ClientStore", ["activeClient"])
    },
    methods: {
        updateCodeField(value, field, index) {
            Store.commit("ClientStore/updateActiveClientCodeProperty", {
                prop: field,
                value: value,
                index: index
            });
        },
        addNewCode() {
            Store.commit("ClientStore/addNewClientCode");
        },
        deleteCode(index) {
            if (confirm(this.t("Are you sure you want to delete this code?"))) {
                Store.commit("ClientStore/deleteClientCode", index);
            }
        }
    }
};
</script>

<style scoped>
.codes-edit-content {
    padding: 0 20px 12px 20px;
}

.code-block {
    margin-bottom: 8px;
}

.edit-row {
    display: flex;
    align-items: center;
    min-height: 32px;
    margin-bottom: 4px;
}

.row-title {
    color: #888;
    width: 140px;
    flex-shrink: 0;
    font-size: 13px;
}

.compact-input {
    flex: 1;
    max-width: 300px;
}

::v-deep .compact-input .v-input__slot {
    min-height: 28px !important;
    padding: 0 8px !important;
}

::v-deep .compact-input input {
    padding: 4px 0 !important;
    font-size: 13px;
}

::v-deep .compact-input .v-select__selections {
    padding: 0 !important;
    font-size: 13px;
}

::v-deep .compact-input .v-select__selection {
    font-size: 13px;
}

::v-deep .compact-input .v-input__prepend-inner,
::v-deep .compact-input .v-input__append-inner {
    margin-top: 4px !important;
}
</style>
